import dataServices from '@/shared/api/dataServices';
// import { set } from 'lodash';

import {
  GET_HUNTER
} from '../mutation-types';

export const state = () => ({
  hunter: {}
});

const mutations = {
  [GET_HUNTER](state, hunterData) {
    state.hunter = hunterData;
  }
};

const actions = {
  async getHunterDataAction({ commit }) {
    const hunterData = await dataServices.getHunterData();
    commit(GET_HUNTER, hunterData);
  }
};

const getters = {
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
